import { useReducedMotion } from 'framer-motion';

// Animation variants for page transitions
export const pageVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -20
  }
};

// Transition configuration
export const pageTransition = {
  type: 'tween',
  ease: 'easeInOut',
  duration: 0.3
};

// Slide variants (for directional transitions)
export const slideVariants = {
  initial: (direction = 1) => ({
    opacity: 0,
    x: direction > 0 ? 100 : -100
  }),
  animate: {
    opacity: 1,
    x: 0
  },
  exit: (direction = 1) => ({
    opacity: 0,
    x: direction > 0 ? -100 : 100
  })
};

// Zoom variants
export const zoomVariants = {
  initial: {
    opacity: 0,
    scale: 0.95
  },
  animate: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0,
    scale: 0.95
  }
};

// Scale variants
export const scaleVariants = {
  initial: {
    opacity: 0,
    scale: 0.9
  },
  animate: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0,
    scale: 1.05
  }
};

// Fade only (minimal animation)
export const fadeVariants = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};

// Hook to get appropriate variants based on user preferences
export const useAnimationVariants = () => {
  const shouldReduceMotion = useReducedMotion();
  
  // If user prefers reduced motion, use fade only
  if (shouldReduceMotion) {
    return {
      variants: fadeVariants,
      transition: { duration: 0.2 }
    };
  }
  
  // Default: use page variants with full animation
  return {
    variants: pageVariants,
    transition: pageTransition
  };
};

// Export default configuration
export default {
  pageVariants,
  pageTransition,
  slideVariants,
  zoomVariants,
  scaleVariants,
  fadeVariants,
  useAnimationVariants
};